import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CheckBox extends Component {
	constructor(props) {
		super(props);

		const { active, disabled } = this.props;

		this.state = {
			active: active,
			disabled: disabled,
		};
	}
	checkMe = () => {
		this.props.onCheck();
	};
	componentDidUpdate(prevProps) {
		const { active, disabled } = this.props;
		if (active !== prevProps.active) {
			this.setState({ active: active });
		}
		if (disabled !== prevProps.disabled) {
			this.setState({ disabled: disabled });
		}
	}
	render() {
		const { id, name, extraClass } = this.props;
		const { active, disabled } = this.state;
		const { checkMe } = this;

		var className = `check-item ${extraClass ? extraClass : ''} ${
			disabled ? 'disabled' : ''
		}`;

		return (
			<div className={className}>
				<input
					type="checkbox"
					id={id}
					checked={active}
					onChange={checkMe}
				/>
				<label htmlFor={id} className="check-box">
					<div className="check-text">{name}</div>
				</label>
			</div>
		);
	}
}

// PropTypes
CheckBox.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	active: PropTypes.bool,
	onCheck: PropTypes.func.isRequired,
	extraClass: PropTypes.string,
	disabled: PropTypes.bool,
};

export default CheckBox;
